import { render, staticRenderFns } from "./Demographics.vue?vue&type=template&id=1f6aa821&scoped=true&"
import script from "./Demographics.vue?vue&type=script&lang=js&"
export * from "./Demographics.vue?vue&type=script&lang=js&"
import style0 from "./Demographics.vue?vue&type=style&index=0&id=1f6aa821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6aa821",
  null
  
)

export default component.exports